export default __webpack_public_path__ + "static/media/TF_25.0c4ea929.png";